import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

/**
 * Polls the unified Stripe session endpoint when the URL has ?session_id=...
 * Runs up to 5 attempts, 2s apart. On "paid" calls onPaid() and clears the param.
 */
export function useStripeReturn(onPaid) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (!sessionId) return;
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled || attempts >= 5) return;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data?.payment_status === "paid") {
          toast.success("Pago exitoso! Tu pedido esta siendo procesado.");
          searchParams.delete("session_id");
          setSearchParams(searchParams, { replace: true });
          if (onPaid) onPaid(data);
          return;
        }
        if (data?.status === "expired" || data?.status === "canceled") {
          toast.error("Pago cancelado o expirado");
          searchParams.delete("session_id");
          setSearchParams(searchParams, { replace: true });
          return;
        }
      } catch {
        /* ignore, retry */
      }
      attempts++;
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
}
